import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { REPORT } from "../config/apiEndPoint";
import { POST } from "config/api.config";

/** POST `Report/eligible/filter` */
export const submitEligibleReportFilterData = async (data = {}) => {
  try {
    const response = await POST(REPORT.ELIGIBLE_FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
